import i18n from 'config/i18n';
import * as yup from 'yup';

import { getLocale } from 'utils/date';

function getSchema() {
  const t = i18n.getFixedT(getLocale(), 'common');

  return yup
    .object({
      displayDutyCode: yup
        .string()
        .required(t('validationFieldRequired', { name: t('dutyCode') })),
      colorCode: yup.string(),
      overrideDutyCodeId: yup.mixed().when('isNumber', {
        is: (val: any) => typeof val === 'number',
        then: yup
          .number()
          .min(
            1,
            t('validationFieldRequired', { name: t('overrideDutyCode') })
          ),
        otherwise: yup.string()
      })
    })
    .required();
}

export default getSchema;
